import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { SharedModule } from '../../../core/modules/shared.module'
import { Ng2DeviceDetectorModule } from 'ng2-device-detector'
import { LoginComponent } from './login.component'

const routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'inloggen/magic-token/:token',
    component: LoginComponent,
  },
]

@NgModule({
  declarations: [LoginComponent],
  imports: [SharedModule, RouterModule.forChild(routes), Ng2DeviceDetectorModule.forRoot()],
  exports: [LoginComponent],
})
export class LoginModule {}



// WEBPACK FOOTER //
// ./src/app/main/authentication/login/login.module.ts